export default "__VITE_ASSET__Cxr7RQJ0__"